import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Hero from "src/components/Hero/Hero";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import EventFinished from "src/components/EventFinished";
import AppDownloadBanner from "src/components/AppDownloadBanner/AppDownloadBanner";

const LuxonPayGiveaway2026 = () => {
  const { t } = useTranslation();
  const heroImage = t(`luxonPayGiveaway2026.hero.image`);

  return (
    <Wrapper>
      <EventFinished
        scheduleKeyName="luxonPayGiveaway2026"
        eventType="promotion"
      />
      <Hero
        image={heroImage}
        bgImage={t(`luxonPayGiveaway2026.hero.bgImage`)}
        imageAlt={t(`luxonPayGiveaway2026.hero.imageAlt`)}
        fluidImage={heroImage ? false : true}
      />
      <AppDownloadBanner
        text={t(`luxonPayGiveaway2026.hero.downloadText`)}
        appStoreUrl={t(`luxonPayGiveaway2026.hero.appStoreUrl`)}
        googlePlayUrl={t(`luxonPayGiveaway2026.hero.googlePlayUrl`)}
      />
      <container-div>
        <TitleSection
          as={"h2"}
          title={t(`luxonPayGiveaway2026.content.title`)}
          text={t(`luxonPayGiveaway2026.content.text`)}
          className="mt-4 pb-2"
        />
        <SubTitleSection
          as={"h2"}
          subTitle={t(`luxonPayGiveaway2026.content.howToEnter.title`)}
          text={t(`luxonPayGiveaway2026.content.howToEnter.text`)}
          className="py-0 mt-4 mb-4"
        />
      </container-div>
      <div className="rules-section" id="terms">
        <container-div>
          <div className="rules-card">
            <h4>{t(`luxonPayGiveaway2026.terms.title`)}</h4>
            <ReactMarkdown>
              {t(`luxonPayGiveaway2026.terms.list`, { returnObjects: false })}
            </ReactMarkdown>
          </div>
        </container-div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  background-color: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  text-wrap: balance;

  .hero_text_container {
    display: none;
  }

  .subtitle-section {
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;

    h2:after {
      margin: 0 auto;
    }

    ul {
      list-style-position: inside;
      padding-left: 0;
      margin-left: 0;
    }

    li,
    p {
      text-align: center;
    }
  }

  .rules-section {
    background-color: #111;
    padding: 20px 0;
    text-align: left;
  }

  .rules-card {
    background-color: #000;
    max-width: 1440px;
    margin: 0 auto;
    padding: 1rem 2rem 2rem;
    color: #999;
  }

  .rules-card h4 {
    color: #999;
    font-weight: 700;
    font-size: 30px;
    margin: 5px 0 20px 0;
    padding: 15px;
    text-transform: uppercase;
    text-align: center;
  }

  .rules-card ol {
    margin-top: 0;
    margin-bottom: 10px;
    padding-left: 1.5rem;
  }

  .rules-card li {
    color: #999;
    font-size: 16px;
    margin-bottom: 8px;
    white-space: normal;
  }

  .rules-card p {
    margin: 10px 0;
  }
`;

export default LuxonPayGiveaway2026;
